// About
import React from 'react';
import styles from './About.module.sass';
import { CreatorProfile, CreatorProfileType } from 'types/profile';
import { socialRecordToLinks } from 'utils/creator';
import { trackEvent } from 'services/analytics';
import SkillsCard from './SkillsCard';
import AboutCard from './AboutCard';
import SocialCard from './SocialCard';
import cn from 'classnames';

export type AboutProps = Pick<
  CreatorProfile,
  | 'about'
  | 'socials'
  | 'socialCategories'
  | 'contentCategories'
  | 'environment'
  | 'equipment'
> & {
  profileType: CreatorProfileType;
};

const About: React.FC<AboutProps> = ({
  socials,
  about,
  profileType,
  socialCategories = [],
  contentCategories = [],
  environment = [],
  equipment = [],
}) => {
  const trackEditProfileClick = () => {
    trackEvent('Creator Clicks Edit Profile Link');
  };

  const socialLinks = socialRecordToLinks(socials);
  if (!Array.isArray(environment)) {
    environment = Object.values(environment);
  }
  if (!Array.isArray(equipment)) {
    environment = Object.values(environment);
  }

  const hideSocial = socialLinks.length < 1 || profileType === 'public';
  const hideAbout = profileType !== 'personal' && !about;
  const skillsLength =
    contentCategories.length +
    socialCategories.length +
    environment.length +
    equipment.length;
  const hideSkills = skillsLength === 0 && profileType !== 'personal';

  // If only 1 card is visible is full width
  const singleColumn =
    [hideSocial, hideAbout, hideSkills].filter((hidden) => !hidden).length < 2;

  return (
    <div
      className={cn(styles.about, {
        [styles.multiColumn]: !singleColumn,
      })}
    >
      <div className={styles.leftColumn}>
        {!hideAbout && (
          <AboutCard
            about={about}
            profileType={profileType}
            trackEditProfileClick={trackEditProfileClick}
          />
        )}
        {!hideSocial && (
          <SocialCard
            socialLinks={socialLinks}
            profileType={profileType}
            trackEditProfileClick={trackEditProfileClick}
          />
        )}
      </div>
      {!hideSkills && (
        <SkillsCard
          profileType={profileType}
          contentCategories={contentCategories}
          socialCategories={socialCategories}
          environment={environment}
          equipment={equipment}
        />
      )}
    </div>
  );
};

export default About;

export const IncompleteTag: React.FC = () => (
  <div className={styles.incompleteTag}>Incomplete</div>
);
